import React from "react";

function HeroMessage( { slogan } ) {
	return (
        <>
		<div className="heroContainer">
				<img src="/images/dipIcon.svg" alt="Right Arrow" className="heroIcon" />
                    <span className="heroSlogan">{slogan}</span>
            
		</div>
        </>
	);
}

export default HeroMessage;
